import { render, staticRenderFns } from "./AgoraList.vue?vue&type=template&id=708edb00&"
import script from "./AgoraList.vue?vue&type=script&lang=js&"
export * from "./AgoraList.vue?vue&type=script&lang=js&"
import style0 from "./AgoraList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports